/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 10.09.2016.
 */
import YoutubePlayer from './youtube-player';

export default YoutubePlayer;



// WEBPACK FOOTER //
// ./src/containers/Player/YoutubePlayer/index.js